import React from "react";
import { useUrl } from "../../../../hooks/usePage";
import { Pagetype } from "../../../../interfaces/Config";
import { Route, Switch } from "react-router";

import PadPreview from "../WorkshopPreview/PadPreview/PadPreview";
import TeacherWorkshopsList from "./TeacherWorkshopsList/TeacherWorkshopsList";
import { ROUTES } from "../const";
import TeacherWorkshopPreview from "./TeacherWorkshopPreview/TeacherWorkshopPreview";
import PadGroupForm from "./PadCreation/PadGroupForm";

const Router = () => {
    const basepath = useUrl(Pagetype.WORKMODE_WORKSHOP);

    return (
        <Switch>
            <Route path={`${basepath}/${ROUTES.padPreview}/:workshopId/:padId`}>
                <PadPreview />
            </Route>
            <Route path={`${basepath}/${ROUTES.preview}/:workshopId`}>
                <TeacherWorkshopPreview />
            </Route>
            <Route path={`${basepath}/${ROUTES.padCreation}/:workshopId`}>
                <PadGroupForm />
            </Route>
            <Route path={basepath}>
                <TeacherWorkshopsList />
            </Route>
        </Switch>
    );
};
export default Router;
